const initialState = {
  isLoadingBookToTaxDifferences: false,
  bookToTaxDifferences: [],
  accounts: [],
  isFetchingAccounts: false,
  bookToTaxCodeDescriptions: [],
  uploadedBookToTaxDifferences: [],
  countries: [],
  selectedCountry: {
    countryCode: null,
  },
};

export default initialState;
